import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "closeable"];
import classNames from 'classnames';
import UIAlert from './UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const UIFloatingAlert = props => {
  const {
      children,
      className,
      closeable = true
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIAlert, Object.assign({}, rest, {
    className: classNames('private-floating-alert', className),
    closeable: closeable,
    children: children
  }));
};
UIFloatingAlert.displayName = 'UIFloatingAlert';
export default UIFloatingAlert;